import React from 'react';
import { Link } from 'react-router-dom';

const donutData = [
  { id: 1, name: 'Apple Pie Donut', image: '/donuts/apple.png' },
  { id: 2, name: 'Frosted Donut', image: '/donuts/frosted.png' },
  { id: 3, name: 'Reeses Topped Donut', image: '/donuts/reesestopped.png' },
  { id: 4, name: 'Lemon Poppyseed Donut', image: '/donuts/lemonpoppy.png' },
];

const ExploreDonuts: React.FC = () => {
  return (
    <section className="section bg-white">
      <div className="container-base">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="section-title">Explore Donuts</h2>
          <p className="section-subtitle mx-auto px-4">
            Discover our favorite flavors below
          </p>
        </div>

        {/* Donut Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 mb-8 sm:mb-10">
          {donutData.map((donut) => (
            <div
              key={donut.id}
              className="group card card-hover overflow-hidden"
            >
              <div className="aspect-square bg-gradient-to-br from-orange-50 to-orange-100/50 p-6 sm:p-8 flex items-center justify-center">
                <img
                  src={donut.image}
                  alt={donut.name}
                  className="w-full h-full object-contain drop-shadow-lg transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              <div className="p-4 sm:p-5 text-center border-t border-gray-100">
                <h3 className="text-body font-semibold text-gray-800">{donut.name}</h3>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link to="/menu" className="btn-primary">
            View Full Menu
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ExploreDonuts;
